export default "__VITE_ASSET__kq92v1dG__"